document.addEventListener("DOMContentLoaded", () => {
  /**
   * 给图片添加alt属性，如果图片本身不带文字，则需要alt控制，如果图片带文字，需要写alt具体文字
   *
   */

  function imgAltFun() {
    const images = document.getElementsByTagName("img");

    Array.from(images).forEach((image) => {
      if (!image.hasAttribute("alt")) {
        image.setAttribute("alt", "sainsmartjr");
      }
    });
  }

  function KlaviyoALTFun() {
    setTimeout(function () {
      const image = document.querySelector(".needsclick img");
      if (image) {
        image.setAttribute("alt", "sainsmartjr");
      }
    }, 2000);
  }

  function iframeTitleFun() {
    const iframes = document.getElementsByTagName("iframe");

    Array.from(iframes).forEach((iframe) => {
      if (!iframe.hasAttribute("title")) {
        iframe.setAttribute("title", "sainsmartjr");
      }
    });
  }

  imgAltFun();
  KlaviyoALTFun();
  iframeTitleFun()
});
